module.exports = __webpack_public_path__ + "img/plus.97b25370.svg";